<template>
  <div id="leftAside">
    <div class="flexBox">
      <!-- 平罗总览 -->
      <div class="f_left_pingluozonglan left_">
        <div class="f_pingluo_top">
          <div>
            <span class="f_img_border"><img :src="f_img_line" alt="" /></span>
            <span class="f_font_border"><img :src="f_font_two" alt="" /></span>
          </div>
          <!-- 图标 -->
          <div @click="dialogVisible = true">
            <img :src="f_font_one" alt="" style="cursor: pointer" />
          </div>
        </div>
        <!-- 平罗总览 弹框 -->
        <div>
          <el-dialog
            :visible.sync="dialogVisible"
            width="50%"
            :modal="moadl"
            :close-on-click-modal="false"
            :show-close="false"
            :destroy-on-close="true"
            center
          >
            <span slot="title">
              <img :src="f_font_two" alt="" class="dialog-title" />
            </span>
            <img
              :src="detail_icon_one"
              alt=""
              class="close-icon"
              @click="dialogVisible = false"
            />
            <div>
              <DetailPingluo></DetailPingluo>
            </div>
          </el-dialog>
        </div>
        <div class="f_pingluo_cont">
          <div>
            <div class="jiantou">
              <span>总面积</span>
            </div>
            <div class="font_PI">
              <span class="font_PI_one">{{ totalArea }}</span>
              <span class="font_PI_two">km²</span>
            </div>
          </div>
          <div>
            <div class="jiantou">
              <span>常住人口</span>
              <img
                v-if="populationChange == 1"
                :src="f_font_three"
                alt=""
                class="dou1"
              />
              <span v-if="populationChange == 0"></span
              ><img
                v-if="populationChange == -1"
                :src="f_font_four"
                alt=""
                class="dou2"
              />
            </div>
            <div class="font_PI">
              <span class="font_PI_one">{{ population }}</span>
              <span class="font_PI_two">万人</span>
            </div>
          </div>
          <div>
            <div class="jiantou">
              <span>生产总值</span>
              <img
                v-if="gdpChange == 1"
                :src="f_font_three"
                alt=""
                class="dou1"
              />
              <span v-if="gdpChange == 0"></span>
              <img
                v-if="gdpChange == -1"
                :src="f_font_four"
                alt=""
                class="dou2"
              />
            </div>
            <div class="font_PI">
              <span class="font_PI_one">{{ gdp }}</span>
              <span class="font_PI_two">亿元</span>
            </div>
          </div>
          <div>
            <div class="jiantou">
              <div style="display: inline-block">
                <span style="display: block">城镇居民</span>
                <span>人均可支配收入</span>
              </div>
              <img
                v-if="pcdiChange == -1"
                :src="f_font_four"
                alt=""
                class="dou2"
              />
              <span v-if="pcdiChange == 0"></span>
              <img
                v-if="pcdiChange == 1"
                :src="f_font_three"
                alt=""
                class="dou1"
              />
            </div>
            <div class="font_PI" style="    text-align: left;">
              <span class="font_PI_one">{{ pcdi }}</span>
              <span class="font_PI_two">元</span>
            </div>
          </div>
          <div>
            <div class="jiantou">
              <div style="display: inline-block">
                <span style="display: block">农村居民</span>
                <span>人均可支配收入</span>
              </div>
              <img
                v-if="cpiChange == -1"
                :src="f_font_four"
                alt=""
                class="dou2"
              />
              <span v-if="cpiChange == 0"></span>
              <img
                v-if="cpiChange == 1"
                :src="f_font_three"
                alt=""
                class="dou1"
              />
            </div>
            <div class="font_PI" style="    text-align: left;">
              <span class="font_PI_one">{{ cpi }}</span>
              <span class="font_PI_two">元</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 数字产业 -->
      <div class="f_left_shuzipingluo left_">
        <div class="f_pingluo_top">
          <div>
            <span class="f_img_border"><img :src="f_img_line" alt="" /></span>
            <span class="f_font_border"><img :src="f_font_five" alt="" /></span>
          </div>
          <!-- 图标 -->
          <div @click="dialogVisibleNumNongye = true">
            <img :src="f_font_one" alt="" style="cursor: pointer" />
          </div>
        </div>
        <div
          :class="
            Animationflag == 1
              ? 'Seed_industry mt10 mb16 Highlight'
              : 'noBefore mt10 mb16'
          "
        >
          <div class="div">
            <div class="nongye_img">
              <img :src="nongye_img_zhizao" alt="" />
            </div>
            <div class="font_PI">制种产业</div>
          </div>
          <div class="div">
            <div>总面积</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ seedArea }}</span>
              <span class="font_PI_two">万亩</span>
            </div>
          </div>
          <div class="div">
            <div>总产量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ seedNumber }}</span>
              <span class="font_PI_two">万公斤</span>
            </div>
          </div>
        </div>
        <div
          :class="
            Animationflag == 2
              ? 'dairy_industry mb16 Highlight'
              : 'noBefore mb16'
          "
        >
          <div class="div">
            <div class="nongye_img">
              <img :src="nongye_img_nainiu" alt="" />
            </div>
            <div class="font_PI">奶牛产业</div>
          </div>
          <div class="div">
            <div>存栏量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ cowNumber }}</span>
              <span class="font_PI_two">万头</span>
            </div>
          </div>
          <div class="div">
            <div>奶产量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ milkNumber }}</span>
              <span class="font_PI_two">万吨</span>
            </div>
          </div>
        </div>
        <div
          :class="
            Animationflag == 3
              ? 'vegetable_industry mb16 Highlight'
              : 'noBefore mb16'
          "
        >
          <div class="div">
            <div class="nongye_img">
              <img :src="nongye_img_shucai" alt="" />
            </div>
            <div class="font_PI">蔬菜产业</div>
          </div>
          <div class="div">
            <div>上市面积</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ vegetableArea }}</span>
              <span class="font_PI_two">亩</span>
            </div>
          </div>
          <div class="div">
            <div>上市量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ vegetableNumber }}</span>
              <span class="font_PI_two">吨</span>
            </div>
          </div>
        </div>
        <div
          :class="
            Animationflag == 4
              ? 'beef_cattle_industry mb16 Highlight'
              : 'noBefore mb16'
          "
        >
          <div class="div">
            <div class="nongye_img">
              <img :src="nongye_img_rouniu" alt="" />
            </div>
            <div class="font_PI">肉牛产业</div>
          </div>
          <div class="div">
            <div>存栏量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ beefInNumber }}</span>
              <span class="font_PI_two">万头</span>
            </div>
          </div>
          <div class="div">
            <div>出栏量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ beefOutNumber }}</span>
              <span class="font_PI_two">万头</span>
            </div>
          </div>
        </div>
        <div
          :class="
            Animationflag == 5
              ? 'Tibet_lamb_industry mb16 Highlight'
              : 'noBefore mb16'
          "
        >
          <div class="div">
            <div class="nongye_img">
              <img :src="nongye_img_tanyang" alt="" />
            </div>
            <div class="font_PI">羊产业</div>
          </div>
          <div class="div">
            <div>存栏量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ sheepInNumber }}</span>
              <span class="font_PI_two">万只</span>
            </div>
          </div>
          <div class="div">
            <div>出栏量</div>
            <div class="font_PI">
              <span class="font_PI_one">{{ sheepOutNumber }}</span>
              <span class="font_PI_two">万只</span>
            </div>
          </div>
        </div>
        <div class="transaction_data">
          <div
            class="agriculture_logo div"
            @click="dialogVisibleLang = true"
            :class="{ activeColor: dialogVisibleLang == true }"
          >
            土地产权交易
          </div>
          <div
            class="agriculture_logo div"
            @click="dialogVisibleFarmProducts = true"
            :class="{ activeColor: dialogVisibleFarmProducts == true }"
          >
            农产品价格
          </div>
          <div
            class="agriculture_logo div"
            @click="dialogVisibleQuality = true"
            :class="{ activeColor: dialogVisibleQuality == true }"
          >
            质量监测
          </div>
        </div>
        <!-- 数字产业 弹框 -->
        <div>
          <el-dialog
            :visible.sync="dialogVisibleNumNongye"
            width="50%"
            :modal="false"
            :close-on-click-modal="false"
            :show-close="false"
            :destroy-on-close="true"
            center
          >
            <span slot="title">
              <img :src="detail_title" alt="" class="dialog-title" />
            </span>
            <img
              :src="detail_icon_one"
              alt=""
              class="close-icon"
              @click="dialogVisibleNumNongye = false"
            />
            <div>
              <NumFarming />
            </div>
          </el-dialog>
        </div>
        <!-- 土地交易产权 弹框 -->
        <div>
          <el-dialog
            :visible.sync="dialogVisibleLang"
            width="52%"
            :modal="false"
            :close-on-click-modal="false"
            :show-close="false"
            :destroy-on-close="true"
            center
          >
            <span slot="title">
              <img :src="detail_lang_title" alt="" class="dialog-title1" />
            </span>
            <img
              :src="detail_icon_one"
              alt=""
              class="close-icon"
              @click="dialogVisibleLang = false"
            />
            <div>
              <Lang />
            </div>
          </el-dialog>
        </div>
        <!-- 农产品价格 弹框 -->
        <div>
          <el-dialog
            :visible.sync="dialogVisibleFarmProducts"
            width="52%"
            :modal="false"
            :close-on-click-modal="false"
            :show-close="false"
            :destroy-on-close="true"
            center
          >
            <span slot="title">
              <img :src="detail_farm_title" alt="" class="dialog-title1" />
            </span>
            <img
              :src="detail_icon_one"
              alt=""
              class="close-icon"
              @click="dialogVisibleFarmProducts = false"
            />
            <div>
              <FarmProducts />
            </div>
          </el-dialog>
        </div>
        <!-- 质量检测 弹框 -->
        <div class="quaiity">
          <el-dialog
            :visible.sync="dialogVisibleQuality"
            width="52%"
            :modal="false"
            :close-on-click-modal="false"
            :show-close="false"
            :destroy-on-close="true"
            center
          >
            <span slot="title">
              <img :src="detail_quality_title" alt="" class="dialog-title1" />
            </span>
            <img
              :src="detail_icon_one"
              alt=""
              class="close-icon"
              @click="dialogVisibleQuality = false"
            />
            <div style="height: 68vh">
              <Quality />
            </div>
          </el-dialog>
        </div>
      </div>
      <!-- 数字政务 -->
      <div class="f_left_shuzizhengwu left_">
        <div
          class="f_pingluo_top"
          style="border-bottom: 1px dashed rgba(74, 252, 209, 0.6)"
        >
          <div>
            <span class="f_img_border"><img :src="f_img_line" alt="" /></span>
            <span class="f_font_border"><img :src="f_font_six" alt="" /></span>
          </div>
          <div @click="dialogVisibleZhengwu = true">
            <img :src="f_font_one" alt="" style="cursor: pointer" />
          </div>
        </div>
        <!-- 数字政务 弹框 -->
        <div class="zhenwu">
          <el-dialog
            :visible.sync="dialogVisibleZhengwu"
            width="50%"
            :modal="moadl"
            :close-on-click-modal="false"
            :show-close="false"
            :destroy-on-close="true"
            center
          >
            <span slot="title">
              <img :src="detail_icon_zhengwu" alt="" class="dialog-title" />
            </span>
            <img
              :src="detail_icon_one"
              alt=""
              class="close-icon"
              @click="dialogVisibleZhengwu = false"
              style="cursor: pointer"
            />
            <div>
              <DetailDovernmen></DetailDovernmen>
            </div>
          </el-dialog>
        </div>
        <div id="shuzizhengwu" class="f_shuzizhengwu_cont"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import DetailPingluo from "../pingluo_all/detail_pingluo.vue";
import DetailDovernmen from "../digital_government/digital_government.vue";
import NumFarming from "./detail_farming/Num_farming.vue";
import Lang from "./detail_farming/Lang.vue";
import FarmProducts from "./detail_farming/Farm_Products.vue";
import Quality from "./detail_farming/quality.vue";
export default {
  components: {
    DetailPingluo,
    DetailDovernmen,
    NumFarming,
    Lang,
    FarmProducts,
    Quality,
  },
  data() {
    return {
      totalArea: "",
      population: "",
      gdp: "",
      pcdi: "",
      cpi: "",
      acceptance: "",
      caseSum: "",
      completed: "",
      declare: "",
      handle: "",
      populationChange: "",
      pcdiChange: "",
      gdpChange: "",
      cpiChange: "",
      otherWayNum: "",
      villageHandleNum: "",
      dialogVisibleZhengwu: false,
      moadl: false,
      dialogVisible: false,
      detail_icon_zhengwu: require("@/assets/images/蒙版组 18@2x.png"),
      detail_icon_NumPingluo: require("@/assets/images/蒙版组 16@2x.png"),
      detail_icon_one: require("@/assets/images/路径 28736_2@2x.png"),
      f_img_line: require("@/assets/images/line.png"),
      f_img_border: require("@/assets/images/border.png"),
      f_font_one: require("@/assets/images/路径 28803.png"),
      f_font_two: require("@/assets/images/蒙版组 2@2x.png"),
      f_font_three: require("@/assets/images/font_red.png"),
      f_font_four: require("@/assets/images/font_green.png"),
      f_font_five: require("@/assets/images/蒙版组 16.png"),
      chanye_icon_one: require("@/assets/images/组 15056.png"),
      chanye_icon_two: require("@/assets/images/组 15055.png"),
      chanye_icon_three: require("@/assets/images/组 15054.png"),
      f_font_six: require("@/assets/images/蒙版组 18.png"),
      f_font_seven: require("@/assets/images/蒙版组 4.png"),
      f_font_eidht: require("@/assets/images/蒙版组 19.png"),
      f_font_nice: require("@/assets/images/蒙版组 17.png"),
      // 数字产业图标
      nongye_img_zhizao: require("@/assets/images/路径 28788.png"),
      nongye_img_nainiu: require("@/assets/images/组 15075.png"),
      nongye_img_shucai: require("@/assets/images/组 15077.png"),
      nongye_img_rouniu: require("@/assets/images/路径 28797.png"),
      nongye_img_tanyang: require("@/assets/images/路径 28798@2x.png"),
      // 数字产业数据
      beefInNumber: "",
      beefOutNumber: "",
      cowNumber: "",
      milkNumber: "",
      seedArea: "",
      seedNumber: "",
      sheepInNumber: "",
      sheepOutNumber: "",
      vegetableArea: "",
      vegetableNumber: "",
      // 数字产业二级开关
      dialogVisibleNumNongye: false,
      dialogVisibleQuality: false,
      dialogVisibleFarmProducts: false,
      dialogVisibleLang: false,
      // 数字产业二级图标
      detail_title: require("@/assets/images/szcy@2x.png"),
      detail_lang_title: require("@/assets/images/蒙版组 31.png"),
      detail_quality_title: require("@/assets/images/蒙版组 29@2x.png"),
      detail_farm_title: require("@/assets/images/ncp.png"),
      detail_icon_one: require("@/assets/images/路径 28736_2@2x.png"),
      // 数字产业动画切换标志
      Animationflag: 1,
      // 数字政务
      myChart: "",
      numSum: 0,
      months: "",
      dataAxis: [],
      data: [],
      stopflag: false,
    };
  },
  methods: {
    pingluo_all() {
      var pl_zonglan = plOtherDataInterface.getOverallNumber();
      this.totalArea = pl_zonglan.totalArea;
      this.population = pl_zonglan.population;
      this.gdp = pl_zonglan.gdp;
      this.pcdi = pl_zonglan.cpcdi;
      this.cpi = pl_zonglan.vpcdi;
      this.populationChange = pl_zonglan.populationChange;
      this.pcdiChange = pl_zonglan.cpcdiChange;
      this.gdpChange = pl_zonglan.gdpChange;
      this.cpiChange = pl_zonglan.vpcdiChange;
    },
    industry_() {
      var _agriculture = plOtherDataInterface.getAgricultureNumber();
      this.beefInNumber = _agriculture.beefInNumber;
      this.beefOutNumber = _agriculture.beefOutNumber;
      this.cowNumber = _agriculture.cowNumber;
      this.milkNumber = _agriculture.milkNumber;
      this.seedArea = _agriculture.seedArea;
      this.seedNumber = _agriculture.seedNumber;
      this.sheepInNumber = _agriculture.sheepInNumber;
      this.sheepOutNumber = _agriculture.sheepOutNumber;
      this.vegetableArea = _agriculture.vegetableArea;
      this.vegetableNumber = _agriculture.vegetableNumber;
    },

    AnimationflagCount() {
      this.Animationflag++;
      if (this.Animationflag > 5) {
        this.Animationflag = 1;
      }
    },
    skMonthrangeDefault() {
      let date = new Date().getDate();
      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      
      if (date < 15) {
        month--;
        if (month < 0) {
          month = 11;
          year--;
        }
      }
      
      month = month + 1; // Convert from 0-11 to 1-12
      if (month < 10) {
        month = "0" + month;
      }
      
      this.months = year + "-" + month;
      console.log(this.months);
      
      var pl_shuzizhengwu = plOtherDataInterface.getGovernmentNumberByYearMonth(
        this.months
      );
      pl_shuzizhengwu.forEach((element, index) => {
        this.dataAxis.push(element.regionName);
        this.data.push(element.caseSum);
        this.numSum += parseInt(element.caseSum);
      });
    },
    goverment_work() {
      this.myChart = echarts.init(document.getElementById("shuzizhengwu"));
      let option = {
        title: {
          subtext: "月办件量:" + this.numSum,
          right: "3%",
          top: "-5%",
          subtextStyle: {
            color: "rgb(62, 248, 156)",
          },
        },
        tooltip: {
          //提示框组件
          trigger: "item",
          formatter: function (data) {
            console.log(data);
            return "乡镇：" + data.name + "<br/>" + "月办件量：" + data.value;
          },
          axisPointer: {
            //坐标轴指示器
            type: "shadow", //'shadow' 阴影指示器
            label: {
              backgroundColor: "#6a7985",
            },
          },
          textStyle: {
            color: "#000",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12,
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          bottom: "-7%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          boundaryGap: true,
          data: this.dataAxis,
          axisLabel: {
            show: true,
            color: "#fff",
            interval: 0,
            formatter: function (value) {
              var ret = ""; //拼接加\n返回的类目项
              var maxLength = 2; //每项显示文字个数
              var valLength = value.length; //X轴类目项的文字个数
              var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
              if (rowN > 1) {
                //如果类目项的文字大于5,
                for (var i = 0; i < rowN; i++) {
                  var temp = ""; //每次截取的字符串
                  var start = i * maxLength; //开始截取的位置
                  var end = start + maxLength; //结束截取的位置
                  //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                  temp = value.substring(start, end) + "\n";
                  ret += temp; //凭借最终的字符串
                }
                return ret;
              } else {
                return value;
              }
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#999",
          },
        },
        dataZoom: [
          {
            xAxisIndex: 0, // 这里是从X轴的0刻度开始
            show: false, // 是否显示滑动条，不影响使用
            type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
            startValue: 0, // 从头开始。
            endValue: 5, // 一次性展示多少个。
          },
        ],
        series: [
          {
            type: "bar",
            showBackground: true,
            itemStyle: {
              normal: {
                //这里是重点
                color: function (params) {
                  var colorList = [
                    "#F9CD33",
                    "#F86846",
                    "#78C446",
                    "#4FC5EA",
                    "#5ED8A9",
                    "#605AD8",
                  ];
                  return colorList[params.dataIndex % colorList.length];
                },
              },
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" },
                ]),
              },
            },
            data: this.data,
          },
        ],
      };
      if (option && typeof option === "object") {
        this.myChart.setOption(option);
        // i定时自动滚动
        setInterval(() => {
          let cc = this.data;
          if (option.dataZoom[0].endValue == cc.length + 1) {
            option.dataZoom[0].endValue = 5;
            option.dataZoom[0].startValue = 0;
          } else {
            if (!this.stopflag) {
              option.dataZoom[0].endValue = option.dataZoom[0].endValue + 1;
              option.dataZoom[0].startValue = option.dataZoom[0].startValue + 1;
            } else {
            }
          }
          this.myChart.setOption(option);
        }, 2000);
      }
      this.myChart.on("mouseover", this.stop);
      this.myChart.on("mouseout", this.goMove);
      // this.autoMove();
    },
    //自动滚动
    autoMove() {
      var timeOut = setInterval(() => {
        clearInterval(timeOut);
        // 每次向后滚动一个，最后一个从头开始。
        if (this.stopMove) {
          return;
        }
        if (
          Number(this.option.dataZoom[0].endValue) ===
          this.dataY.length - 1
        ) {
          this.option.dataZoom[0].endValue = this.end;
          this.option.dataZoom[0].startValue = 0;
        } else {
          this.option.dataZoom[0].endValue =
            this.option.dataZoom[0].endValue + 1;
          this.option.dataZoom[0].startValue =
            this.option.dataZoom[0].startValue + 1;
        }
        this.chart.setOption(this.option);
      }, 3000);
    },
    //停止滚动
    stop() {
      this.stopflag = true;
    },
    //继续滚动
    goMove() {
      this.stopflag = false;
    },
  },
  mounted() {
    this.skMonthrangeDefault();
    this.pingluo_all();
    this.industry_();
    this.goverment_work();
    this.$nextTick(() => {
      setInterval(this.AnimationflagCount, 2000);
    });
  },
};
</script>

<style lang="less" scoped>
.flexBox {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-around;
}
.f_img_border {
  width: 1.125rem;
  height: 1.125rem;
  margin-right: 0.3125rem;
}
.f_img_border img,
.f_font_border img,
.nongye_img img {
  width: inherit;
  height: inherit;
}
.dialog-title {
  width: 156px;
  height: 40px;
}
.dialog-title1 {
  width: 210px;
  height: 40px;
}
.f_font_border {
  width: 5.625rem;
  height: 1.225rem;
  display: inline-block;
}
.font_PI {
  color: rgb(62, 248, 156);
}
.f_pingluo_cont {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  padding-top: 0.8rem;
}
.nongye_img {
  width: 2rem;
  height: 2rem;
  margin: auto;
}
.first_font {
  text-align: left;
  padding-left: 0.625rem;
  color: #fff;
}
.first_font_cont,
.second_font_cont {
  display: flex;
  justify-content: space-around;
  padding: 0.8rem 0;
  line-height: 28px;
}
.font_PI_one {
  font-size: 24px;
}
.font_PI_two {
  margin-left: 0.1875rem;
}
.font_PI_four {
  font-size: 1.2em;
}
.font_PI_three {
  font-size: 0.75rem;
}
.f_left {
  margin-left: 0.625rem;
}
.chidren_logo {
  background-image: linear-gradient(
    to right,
    rgb(121, 226, 154),
    rgba(62, 248, 156, 0)
  );
  border-left: 4px solid rgb(62, 248, 156);
}
.f_left_pingluozonglan,
.f_left_shuzipingluo,
.f_left_shuzizhengwu {
  margin: 4px 0;
  background: url("../../assets/images/border.png");
  background-repeat: no-repeat;
  font-size: 16px;
  background-size: 100% 100%;
}
.f_pingluo_top {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.475rem;
  border-bottom: 1px solid rgba(74, 252, 209, 0.6);
  position: relative;
}
.f_pingluo_font table {
  width: 100%;
  font-size: 16px;
}
.f_pingluo_font table tr {
  line-height: 1.5625rem;
}
.left_ {
  padding: 9.6px 11.2px;
}
.f_first,
.f_two,
.f_three {
  margin: 0.625rem 0;
}
.f_shuzizhengwu_cont {
  width: 100%;
  height: 10rem;
}
.shuzi_cont {
  margin: 0.5rem 0;
  line-height: 1.875rem;
}
/deep/.el-dialog {
  background: #15606e;
  border: 1px solid rgb(43, 249, 252);
  margin-top: 17vh !important;
}
.quaiity /deep/.el-dialog {
  background: #15606e;
  border: 1px solid rgb(43, 249, 252);
  margin-top: 15vh !important;
}
.zhenwu /deep/.el-dialog {
  background: #15606e;
  border: 1px solid rgb(43, 249, 252);
  margin-top: 19vh !important;
}
.close-icon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 32px;
  right: 41px;
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #0e4560;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */
/deep/.el-dialog--center .el-dialog__body {
  padding: 0 18px 20px;
}

.jiantou {
  span {
    vertical-align: middle;
  }
  img {
    vertical-align: middle;
  }
}
/deep/.el-dialog__header {
  padding: 25px 0 26px;
}
// 上下跳动箭头
.dou1 {
  -webkit-animation: dou1 1s infinite;
  -webkit-animation-fill-mode: both;
}
.dou2 {
  -webkit-animation: dou1 1s infinite;
  -webkit-animation-fill-mode: both;
}
@-webkit-keyframes dou1 {
  0% {
    -webkit-transform: translate(0, -3px);
  }
  30% {
    -webkit-transform: translate(0, 0px);
  }
  60% {
    -webkit-transform: translate(0, -3px);
  }
  100% {
    -webkit-transform: translate(0, -6px);
  }
}
@-webkit-keyframes dou2 {
  0% {
    -webkit-transform: translate(0, 3px);
  }
  30% {
    -webkit-transform: translate(0, 0px);
  }
  60% {
    -webkit-transform: translate(0, 3px);
  }
  100% {
    -webkit-transform: translate(0, 6px);
  }
}
// 数字产业
.Seed_industry,
.dairy_industry,
.vegetable_industry,
.beef_cattle_industry,
.Tibet_lamb_industry,
.transaction_data,
.noBefore {
  display: flex;
  justify-content: space-around;
  position: relative;
}
.mb16 {
  margin-bottom: 1rem;
}
.mt10 {
  margin-top: 0.8rem;
}

.Highlight {
  // -webkit-transform: scale(1.1);
  // 	-moz-transform: scale(1.1);
  // 	-o-transform: scale(1.1);
  -moz-box-shadow: 2px 2px 10px #3ef89c;
  -webkit-box-shadow: 2px 2px 10px #3ef89c;
  box-shadow: 2px 2px 10px #3ef89c;
  //  outline-color: #3ef89c;
  outline-style: dotted;
  outline-width: 1px;
}

.div {
  width: 33%;
}
.f_shuzinongye_cont {
  font-size: 16px;
  line-height: 32px;
  text-align: center;
}
.agriculture_logo {
  height: 2rem;
  background-size: cover;
  background-repeat: no-repeat;
  background: url("../../assets/images/agriculture.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  line-height: 2rem;
  font-size: 0.9rem;
}
.activeColor {
  height: 2rem;
  background-size: cover;
  background-repeat: no-repeat;
  background: url("../../assets/images/agriculture.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  color: rgb(62, 248, 156);
  line-height: 2rem;
  font-size: 0.9rem;
}
</style>





// WEBPACK FOOTER //
// src/components/leftAside/left.vue